const listOfCounselors=[
{ name:'Gaurav Kulkarni',
languages:'English,Marathi',
contact:'998754531',
fees:'800-1500',
medium :'Face to Face,skype,video conference',
specialising:'Sexuality and gender orientation related issues, Trauma, Mental Illness, Relationship Concerns, Work-life Concerns',
field:'Psychiatry',
locality:'Mumbai'},
{
    name:'Manik Bhadkamkar',
    languages:'English,Marathi,Hindi',
    contact:'9987142188',
    fees:'800-1200',
    medium :'Face to face, Through the telephone,Over video conference/skype',
    specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Violence against women, Sexuality and gender orientation related issues, Sexual and reproductive health related concerns, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
    field:'Clinical Psychologist',
    locality:'Mumbai'
},
{ name:'Pushpa Venkatraman',
    languages:'English, Tamil, possibly some Hindi',
    contact:'9869332886',
    fees:'1000',
    medium:'Face to face',
     specialising:'Trauma, Work-life Concerns, Academic and Career Related Issues',
     field:'Counsellor/Psychotherapist',
     locality:'Mumbai'

},
{ name:'Dr Manjiri Deshpande Shenoy',
 contact:'9820330802',
fees:'1000',
 languages:'English,Marathi,Hindi',
 medium:'Face to face',
 specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Violence against women, Sexuality and gender orientation related issues, Sexual and reproductive health related concerns, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
 field:'Psychiatrist',
 locality:'Mumbai'

},
{name:'	Aradhna Agarwal',
contact:'NIL',
fees:'1000-1250',
languages:'Hindi,English',
medium:'Over videoconference/skype',
specialising:'Violence against women, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
field:'Counsellor',
locality:'Chhatisgarh'
},
{name:'Aakanksha Kanojia',
contact:'9716765236',
fees:'1000-1250',
languages:'Hindi,English',
medium:'Face to Face,Over videoconference/skype',
specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Sexuality and gender orientation related issues, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
field:'Counsellor/Psychotherapist',
locality:'Chhatisgarh' 
},
{name:'Dr. Akhil Chopra',
contact:'7060967850',
fees:'500',
languages:'English,Hindi',
medium:'Face to face',
specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties);Substance and habitual addictions;Trauma;Mental Illness;Parenting Concerns',
field:'Psychiatrist',
locality:'Uttarakhand'
},
{name:'Dr. Y.V. Ramana',
contact:'8632256353',
fees:'300',
languages:'English,Telugu',
medium:'Face to face;Through the telephone',
specialising:'Mental Illness',
field:'Psychiatrist',
locality:'Andhra Pradesh'
},
{name:'Dr Dipak Giri',
contact:'9334238982',
fees:'NA',
languages:'English,Hindi,Bengali',
medium:'Face to face',
specialising:'	Special needs (Children with physical. emotional, behavioural and learning difficulties);Mental Illness;Work-life Concerns',
field:'Psychiatrist',
locality:'Jharkhand'
},
{name:'Rashi Sinha',
contact:'8383887084',
fees:'1299',
languages:'English,Hindi',
medium:'Face to face,Through the telephone,Over video conference/skype',
specialising:'Trauma, Mental Illness, Work-life Concerns, Academic and Career Related Issues',
field:'Counsellor/Psychotherapist',
locality:'Bihar'
},
{name:'Shobhika Jaju',
contact:'9049485444',
fees:'800',
languages:'Hindi,English',
medium:'Face to face;Through the telephone;Over videoconference/skype',
specialising:'Sexuality and gender orientation related issues;Mental Illness;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues;Parenting Concerns',
field:'Counsellor/Psychotherapist',
locality:'Goa'
},
{name:'Zina Varugis',
contact:'8805458372',
fees:'800',
languages:'Hindi,English',
medium:'Face to face;Through the telephone;Over videoconference/skype',
specialising:'Trauma;Relationship Concerns;Work-life Concerns;Parenting Concerns',
field:'Counsellor/Psychotherapist',
locality:'Goa'   
},
{
 name:'Zina Varugis',
contact:'8805458372',
fees:'600',
languages:'Hindi,English',
 medium:'Over videoconference/skype',
 specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Relationship Concerns, Work-life Concerns, Parenting Concerns',
field:'Counsellor/Psychotherapist',
locality:'Goa'   
    } ,
 {name:'Dr. Achal Bhagat',
 contact:'9560065735',
 fees:'1500',
 medium:'Face to face',
 languages:'Hindi,English,Punjabi',
 specialising:'Violence against women, Mental Illness, Relationship Concerns, Parenting Concerns',
field:'Psychiatrist',
locality:'Delhi NCR'
  },
  {name:'Dr Jyoti Kapoor',
  contact:'9990818967',
  fees:'1700',
  medium:'Face to face, Through the telephone,,Over videoconference/skype, Through home visits',
  languages:'English',
  specialising:'Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
  field:'Psychiatrist',
locality:'Delhi NCR'
  },
  {name:'Shivani Agarwal',
  contact:'9818846698',
  fees:'800',
  medium:'Face to face',
  languages:'English,Hindi',
  specialising:'Mental Illness',
  field:'Psychiatrist',
locality:'Delhi NCR'

  },
  {name:'Ms. Rashi Kapoor',
  contact:'9810213341',
  fees:'1000',
  medium:'Face to face,Over videoconference/skype',
  languages:'English,Hindi',
  specialising:'Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues',
  field:'Clinical Psychologist',
  locality:'Delhi NCR'
  },
  {name:'Pallav Bonerjee',
  contact:'9582915036',
  fees:'1000',
  medium:'Face to face,Over videoconference/skype',
  languages:'English,Hindi',
  specialising:'Sexuality and gender orientation related issues, Substance and habitual addictions, Mental Illness, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
  field:'Clinical Psychologist',
  locality:'Delhi NCR'

  },
  { name:'Anshuma Kshetrapal',
  contact:'9312503668',
  fees:'1000',
  medium:'Face to face, Over videoconference/skype',
  languages:'English,Hindi',
  specialising:'Violence against women, Trauma, Relationship Concerns, Work-life Concerns, Parenting Concerns',
    field:'Counsellor/Psychotherapist',
    locality:'Delhi NCR'
  },
  {name:'Gariasi Dutta',
  contact:'9864055560',
  fees:'600',
  medium:'Face to face;Through the telephone;Over chat',
  languages:'English,Hindi,Assamese',
  specialising:'Sexuality and gender orientation related issues;Substance and habitual addictions;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues;Parenting Concerns',
  field:'Counsellor/Psychotherapist',
  locality:'Assam'
  },
  {
    name:'Dr. Gaurav Deka',
    contact:'9864055560',
  fees:'1000',
  medium:'Face to face,;Over videoconference/skype',
  languages:'English,Hindi,Assamese',
   specialising:'Sexuality and gender orientation related issues;Sexual and reproductive health related concerns;Substance and habitual addictions;Trauma;Child Sexual Abuse;Mental Illness;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues;Parenting Concerns',
    field:'Counsellor/Psychotherapist',
    locality:'Assam'
  },
  { name:'Dr. Sangeeta Datta',
  contact:'9678615670',
fees:'560',
medium:'Face to face,Through the telephone',
languages:'English,Hindi,Assamese',
specialising:'Mental Illness',
field:'Psychiatrist',
locality:'Assam'
  },
  {name:'Dr Arghya Pal',
   contact:'9674417987',
   fees:'200',
   medium:'Face to face',
   languages:'Bengali, Hindi, English',
   specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Sexuality and gender orientation related issues, Sexual and reproductive health related concerns, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness',
   field:'Pyschiatrist',
   locality:'Kolkata&W.B.'
  },
  {name:'Dr.Nupur Guha Ray',
  contact:'9331297260',
  fees:'400',
  medium:'Face to face,Through the telephone, Over chat, Over videoconference/skype',
  languages:'Bengali, Hindi, English',
  specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Violence against women, Sexuality and gender orientation related issues, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
   field:'Clinical Psychologist',
   locality:'Kolkata&W.B.'
  },
  {name:'Parnasha Gupta Roy',
  contact:'9874277712',
  fees:'300',
  medium:'Face to face, Through the telephone, Through emails, Over chat, Through home visits',
  languages:'Bengali, Hindi, English',
  specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Violence against women, Sexuality and gender orientation related issues, Sexual and reproductive health related concerns, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
  field:'Clinical Psychologist',
  locality:'Kolkata&W.B.'

  },
  {name:'Mansi Poddar',
 contact:'9830015724',
 fees:' 1000',
  medium:'Face to face',
  languages:'Bengali, Hindi, English',
  specialising:' Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns	Trauma, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues',
field:'Counsellor/Psychotherapist',
locality:'Kolkata&W.B.'
  },
  { name:'Charvi Jain',
  contact:'9830072004',
  fees:'500',
  medium:'Face to face',
  languages:'Bengali, Hindi, English',
  specialising:'Violence against women, Sexuality and gender orientation related issues, Substance and habitual addictions, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
    field:'Counsellor/Psychotherapist',
    locality:'Kolkata&W.B.'

  },
  {name:'Ms.Zinnia Bharucha',
 contact:'7573066777',
  fees:'2000',
  medium:'Face to face;Through the telephone;Over videoconference/skype',
  languages:'English, Gujarati and Hindi',
  specialising:'Substance and habitual addictions;Trauma;Child Sexual Abuse;Mental Illness;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues',
   field:'Counsellor/Psychotherapist',
locality:"Gujarat"
  },
  { name:'Rajul Jagdish',
  contact:'8431455791',
   fees:'700',
   medium:'Face to face;Through the telephone;Over videoconference/skype',
   languages:'English, Gujarati and Hindi',
   specialising:'Violence against women;Sexuality and gender orientation related issues;Trauma;Mental Illness;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues;Parenting Concerns',
   field:'Counsellor/Psychotherapist',
   locality:"Gujarat"

  },
  {name:'Dr. Dharmesh Patel',
   contact:'9824317830',
   fees:'800-1000',
   medium:'Face to face',
   languages:'English, Gujarati and Hindi',
   specialising:'Mental Illness;Relationship',
   field:'Psychiatrist',
   locality:"Gujarat"

  },
  { name:'Yash Aswar',
    contact:'9181400000',
    fees:'2500',
   medium:'Face to face;Through the telephone;Over videoconference/skype',
   languages:'English, Gujarati and Hindi',
  specialising:'Special needs',
    field:'Counsellor/Psychotherapist',
    locality:"Gujarat"

  },
  {
    name:'Mitanshi Shah',
    contact:'9913000025',
    fees:'400-650',
   medium:'Face to face;Through the telephone;Over videoconference/skype',
   languages:'English, Gujarati and Hindi',
  specialising:'Trauma;Child Sexual Abuse;Mental Illness;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues;Parenting Concerns;Anxiety and Depression',
    field:'Counsellor/Psychotherapist',
    locality:"Gujarat"

  },
  {name:'Alka Kapoor',
    contact:'9179383554',
    fees:'NA',
    languages:'English, Hindi, Punjabi',
    medium:'Face to face, Through the telephone, Over videoconference/skype',
    specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties), Violence against women, Trauma, Child Sexual Abuse, Mental Illness, Relationship Concerns, Work-life Concerns, Academic and Career Related Issues, Parenting Concerns',
    field:'Clinical Psychologist',
    locality:'Madhya Pradesh'


  },
  {name:'Aman Gouri',
  contact:'7748049690',
  fees:'600',
  languages:'English, Hindi,Kannada',
  medium:'Face to face, Through the telephone, Over videoconference/skype',
  specialising:'Special needs (Children with physical. emotional, behavioural and learning difficulties);Violence against women;Substance and habitual addictions;Trauma;Child Sexual Abuse;Mental Illness;Relationship Concerns;Work-life Concerns;Parenting Concerns',
    field:'Clinical Psychologist',
    locality:'Madhya Pradesh'
  }
  ,{name:'Col (Dr) T R John',
  contact:'9400869999',
  fees:'200',
  languages:'English, Hindi,Malayalam',
  medium:'Face to face',
 specialising:'Violence against women;Sexuality and gender orientation related issues;Sexual and reproductive health related concerns;Substance and habitual addictions;Trauma;Mental Illness;Relationship Concerns;Work-life Concerns;Academic and Career Related Issues;Parenting Concerns',
 field:'Psychiatrist',
 locality:'Kerala'

  }

  



]

export default listOfCounselors;